export default __webpack_public_path__ + "static/media/shield-check.5fca70f7.svg";